import { lifecycleHooks } from 'aurelia';

@lifecycleHooks()
export class LazyLoadingHook {
    compiling(template: HTMLElement) {
        const images = template.querySelectorAll('img:not([loading])');
        for (const img of images) {
            img.setAttribute('loading', 'lazy');
        }
    }
}
